<!--
 * @Description: 
 * @Date: 2024-03-15 10:37:33
-->
<template>
  <div style="padding: 0">
    <router-view
      style="width: 100%; height: 100%; position: relative"
      v-slot="{ Component }"
    >
      <KeepAlive :include="[...keepaliveNames]">
        <component :is="Component"></component>
      </KeepAlive>
    </router-view>
  </div>
</template>

<script setup lang="tsx">
import { toRefs, watch } from 'vue';
import { useKeepaliveStore } from '../store/index';

const { keepaliveNames } = toRefs(useKeepaliveStore());
watch(keepaliveNames, newVal => {
  console.log('newVal', newVal);
});
</script>

<style lang="scss" scoped>
$menusWidth: 200px;
$maxHeight: var(--parent-dom-height);
.box {
  display: flex;
}
.menus {
  width: $menusWidth;
  height: $maxHeight;
  background-color: #fff;
  flex-shrink: 0;
  border-bottom: 1px solid gainsboro;

  .item {
    padding: 14px 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 12px;
    .icon {
      width: 18px;
      line-height: 0;
    }
    p {
      color: #333333;
      font-size: 14px;
    }
    &:hover {
      background-color: var(--xrk-color-primary-light-9);
      opacity: 0.9;
    }
    &.active {
      --active-color: var(--xrk-color-primary);
      p {
        color: var(--xrk-color-primary);
      }
    }
  }
}
.content {
  flex-grow: 1;
  height: $maxHeight;
  background-color: #fff;
  border-radius: 18px;
  padding: 12px;
  overflow: auto;
}
.vertical {
  flex-direction: column;
  gap: 2px;
  height: $maxHeight;
  .menus {
    width: 100%;
    height: initial;
    display: flex;
    flex-wrap: wrap;
    .item {
      padding: 14px 20px;
      justify-content: center;
      &:hover {
        background-color: #fff;
      }
    }
  }
  .content {
    height: auto;
    border-radius: 0;
  }
}
</style>
